import React, { useRef, useEffect } from 'react';
import pulse from '@finn-no/pulse-sdk';

var classes$2 = {"activeLink":"LinkOrButton-module_activeLink__gxnds","passiveLink":"LinkOrButton-module_passiveLink__KU0q-"};

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function trackLink(_ref) {
  var {
    link,
    articleIdx,
    orgName,
    adId,
    trackingVertical,
    trackingSubvertical
  } = _ref;
  if (adId) {
    pulse.trackEvent({
      name: 'VH: Customer content clicked',
      type: 'Click',
      intent: 'Open',
      object: {
        id: 'customer-content-clicked',
        type: 'UIElement',
        elementType: link.active ? 'Button' : 'Link',
        url: link.url,
        name: "Article: ".concat(articleIdx),
        hasExtendedProfile: true,
        items: [{
          type: 'ClassifiedAd',
          id: adId,
          name: 'n/a',
          category: 'n/a'
        }]
      },
      target: {
        id: link.url,
        type: 'ExternalContent',
        name: 'Go to webpage',
        referralCommission: false,
        provider: orgName
      },
      vertical: _objectSpread2({
        name: trackingVertical
      }, trackingSubvertical && {
        subVertical: trackingSubvertical
      })
    });
  }
}
function trackAnchor(adId) {
  pulse.trackEvent({
    type: 'Click',
    intent: 'Show',
    name: 'Click on content module brand',
    object: {
      id: adId,
      type: 'UIElement',
      elementType: 'Link'
    }
  });
}
function trackInView(trackingVertical, adId) {
  pulse.trackEvent({
    type: 'View',
    name: 'Content module',
    object: {
      id: 'content-module',
      type: 'UIElement',
      elementType: 'Module',
      hasExtendedProfile: true,
      items: [{
        type: 'ClassifiedAd',
        id: adId,
        name: 'n/a',
        category: 'n/a'
      }]
    },
    vertical: {
      name: trackingVertical
    }
  });
}

var LinkOrButton = _ref => {
  var {
    link,
    articleIdx,
    adId,
    orgName,
    trackingVertical,
    trackingSubvertical
  } = _ref;
  if (link.active) {
    return /*#__PURE__*/React.createElement("a", {
      className: "button px-32 py-12 ".concat(classes$2.activeLink),
      style: {
        minWidth: '250px'
      },
      href: link.url,
      onClick: () => trackLink({
        link,
        articleIdx,
        orgName,
        adId,
        trackingVertical,
        trackingSubvertical
      })
    }, link.text);
  }
  return /*#__PURE__*/React.createElement("a", {
    className: classes$2.passiveLink,
    href: link.url,
    onClick: () => trackLink({
      link,
      articleIdx,
      orgName,
      adId,
      trackingVertical,
      trackingSubvertical
    })
  }, link.text);
};

var classes$1 = {"articleHeading":"ArticleComponent-module_articleHeading__WYbeT","article":"ArticleComponent-module_article__cSU85","articleLinkOrButton":"ArticleComponent-module_articleLinkOrButton__Cqzfr"};

var ArticleComponent = _ref => {
  var {
    article,
    articleIdx,
    adId,
    orgName,
    trackingVertical,
    trackingSubvertical
  } = _ref;
  return /*#__PURE__*/React.createElement("article", {
    className: "".concat(classes$1.article)
  }, /*#__PURE__*/React.createElement("div", {
    className: "aspect-w-16 aspect-h-9"
  }, /*#__PURE__*/React.createElement("img", {
    src: article.media.url,
    className: "w-full h-full object-center object-cover rounded-8",
    alt: ""
  })), /*#__PURE__*/React.createElement("h3", {
    className: "h4 my-16 ".concat(classes$1.articleHeading)
  }, article.heading), /*#__PURE__*/React.createElement("p", {
    className: "mb-16"
  }, article.ingress), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes$1.articleLinkOrButton)
  }, /*#__PURE__*/React.createElement(LinkOrButton, {
    link: article.link,
    articleIdx: articleIdx,
    adId: adId,
    orgName: orgName,
    trackingVertical: trackingVertical,
    trackingSubvertical: trackingSubvertical
  })));
};

var SingleArticle = _ref => {
  var {
    article,
    adId,
    orgName,
    trackingVertical,
    trackingSubvertical
  } = _ref;
  return /*#__PURE__*/React.createElement("article", {
    className: "grid f-grid grid-cols-1 md:grid-cols-5 md:gap-x-20 pb-32 md:pb-64"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h4 md:h2 col-span-1 md:col-span-2 mb-16 md:order-1 order-2"
  }, article.heading), /*#__PURE__*/React.createElement("div", {
    className: "mb-16 md:mb-0 col-span-1 row-span-1 md:col-span-3 md:row-span-4 aspect-w-16 aspect-h-9 md:order-2 order-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: article.media.url,
    className: "w-full h-full object-center object-cover rounded-8",
    alt: ""
  })), /*#__PURE__*/React.createElement("p", {
    className: "col-span-1 md:col-span-2 mb-16 md:mb-40 order-3"
  }, article.ingress), /*#__PURE__*/React.createElement("div", {
    className: "col-span-1 md:col-span-2 order-4"
  }, /*#__PURE__*/React.createElement(LinkOrButton, {
    link: article.link,
    articleIdx: 0,
    adId: adId,
    orgName: orgName,
    trackingVertical: trackingVertical,
    trackingSubvertical: trackingSubvertical
  })));
};

var classes = {"expandableLogoHeader":"ContentModule-module_expandableLogoHeader__EDKVg","linkToContent":"ContentModule-module_linkToContent__G70JA"};

var ContentModule = _ref => {
  var {
    contentModule,
    logoUrl,
    orgName,
    adId,
    headerState = 'original',
    trackingVertical,
    trackingSubvertical
  } = _ref;
  var ref = useRef(null);
  useEffect(() => {
    if (headerState === 'original') {
      var observer = new IntersectionObserver(_ref2 => {
        var [entry] = _ref2;
        if (entry.isIntersecting) {
          trackInView(trackingVertical, adId);
          observer.disconnect();
        }
      }, {
        threshold: 0.5
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }
    return undefined;
  }, []);
  var rootStyles = {
    '--content-module-passivelink-text-color': contentModule.textColor,
    '--content-module-activelink-text-color': contentModule.ctaButton.textColor,
    '--content-module-activelink-bgcolor': contentModule.ctaButton.backgroundColor,
    '--content-module-activelink-bgcolor-hover': contentModule.ctaButton.backgroundHoverColor,
    '--content-module-activelink-bgcolor-active': contentModule.ctaButton.backgroundActiveColor,
    backgroundColor: contentModule.backgroundColor,
    color: contentModule.textColor,
    borderRadius: headerState === 'original' ? '8px' : ''
  };
  var logoAlignment = contentModule.backgroundColor === contentModule.logoBackgroundColor ? 'justify-right' : 'justify-center px-24';
  var renderArticles = articles => {
    if (articles.length === 0) {
      return /*#__PURE__*/React.createElement("div", null, "Auda! her var det jo ingen artikler");
    }
    if (articles.length === 1) {
      return /*#__PURE__*/React.createElement(SingleArticle, {
        article: articles[0],
        adId: adId,
        orgName: orgName,
        trackingVertical: trackingVertical,
        trackingSubvertical: trackingSubvertical
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "md:flex "
    }, articles.slice(0, 3).map((article, idx) => /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "pb-56 md:flex-1 ".concat(idx > 0 ? 'md:ml-32' : '')
    }, /*#__PURE__*/React.createElement(ArticleComponent, {
      article: article,
      articleIdx: idx,
      adId: adId,
      orgName: orgName,
      trackingVertical: trackingVertical,
      trackingSubvertical: trackingSubvertical
    }))));
  };
  var header = logoUrl && /*#__PURE__*/React.createElement("h2", {
    className: "inline-flex items-center ".concat(logoAlignment, " py-16 mb-0"),
    style: {
      backgroundColor: contentModule.logoBackgroundColor,
      maxWidth: '300px',
      height: '75px'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    alt: "Logo for ".concat(orgName, "."),
    style: {
      maxHeight: '43px'
    }
  }));
  if (headerState === 'onlyHeader') {
    return /*#__PURE__*/React.createElement("section", {
      className: "contentModule page-container",
      "aria-label": "Innhold fra megler.",
      style: rootStyles
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center"
    }, header, /*#__PURE__*/React.createElement("a", {
      id: classes.linkToContent,
      className: "ml-24 text-16 underline",
      style: {
        color: contentModule.textColor
      },
      tabIndex: -1,
      href: "#adview-content-module-logo-only-header-content",
      onClick: () => trackAnchor(adId)
    }, "Se v\xE5re artikler")));
  }
  return /*#__PURE__*/React.createElement("section", {
    className: "contentModule page-container",
    id: "adview-content-module-logo-only-header-content",
    "aria-label": "Innhold fra megler.",
    ref: ref,
    style: rootStyles
  }, /*#__PURE__*/React.createElement("span", {
    className: "bg-transparent flex"
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "bg-transparent pt-32"
  }, renderArticles(contentModule.articles)));
};

export { ContentModule };
//# sourceMappingURL=index.esm.js.map
